import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function OrderSuccess() {
  const [params] = useSearchParams();
  const status = params.get("status") || "received";
  const id = params.get("id");
  return (
    <div className="mx-auto max-w-2xl px-5 py-24 text-center md:px-8">
      <div className="grid place-items-center">
        <div className="grid h-20 w-20 place-items-center rounded-full bg-cyan-100">
          <CheckCircle2 className="h-10 w-10 text-cyan-700" />
        </div>
      </div>
      <h1 className="mt-6 font-display text-3xl font-bold text-slate-900">Order received</h1>
      <p className="mt-2 text-slate-600">
        {status === "pending_verification"
          ? "We've received your order and will confirm receipt of your payment shortly."
          : "Thanks for your order! We'll be in touch with shipping/service details."}
      </p>
      {id && <div className="mt-2 text-xs text-slate-400">Reference: {id}</div>}
      <div className="mt-8 flex justify-center gap-3">
        <Link to="/shop" className="btn-ghost-aqua" data-testid="success-continue-shopping-link">Continue shopping</Link>
        <Link to="/" className="btn-aqua" data-testid="success-home-link">Back home</Link>
      </div>
    </div>
  );
}
